// VehicleImageModal.js
import React, { useRef, useState } from 'react';
import { Modal, Carousel, Image, Typography, Button, Select, Empty, Dropdown, message } from 'antd';
import { LeftOutlined, RightOutlined, DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { fileZipService } from '../services';
import { useParams } from 'react-router-dom';
import { Spin } from 'antd'; // Make sure Spin is imported

const { Option } = Select;
const { Text } = Typography;
const CustomArrow = {
    position: "absolute",
    top: "48%",
    color: "black",
    backgroundColor: "#F2F8FB", // Corrected background syntax
    border: "none",
    padding: "5px",
    borderRadius: "100%", // Corrected the border-radius syntax
    cursor: "pointer",
    textAlign: "center"
};

const VehicleImageModal = ({
    modalVisible,
    setModalVisible,
    containerImages,
    vehicles
    //   selectedVehicle,
    //     setSelectedVehicle,
    //     handleCarChange,
    //     vehicleImages = [],
    //     images = [],
    //     singleVehicleImg = [],
    //     modalIndex,
    //     setModalIndex,
    //     modalIndex2,
    //     setModalIndex2,
    //     modalCarouselRef,
    //     modalCarouselRef2,
    //     thumbnailRefs,
    //     thumbnailRefs2,
    //     downloadMenu,
    //     downloadLoading,
}) => {
    const { id } = useParams();

    const modalCarouselRef = useRef(null);
    const thumbnailRefs = useRef([]);
    const modalCarouselRef2 = useRef(null);
    const thumbnailRefs2 = useRef([]);

    const [vehicleLoading, setVehicleLoading] = useState(false)

    const [modalIndex, setModalIndex] = useState(0);
    const [modalIndex2, setModalIndex2] = useState(0)

    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [singleVehicleImg, setSingleVehicleImg] = useState([]);
    const [downloadLoading, setDownloadLoading] = useState(false)

    const [previewVisible, setPreviewVisible] = useState(false);
    const [startIndex, setStartIndex] = useState(0);

    const [previewVisible2, setPreviewVisible2] = useState(false);
    const [startIndex2, setStartIndex2] = useState(0);


    const handleCarChange = (id) => {
        setSelectedVehicle(id);
        setVehicleLoading(true)
        const matchedVehicle = vehicles.find(v => v.id === id);
        setSingleVehicleImg(matchedVehicle?.images || []);
        setTimeout(() => {
            setVehicleLoading(false)
        }, 500)
    };
    const handleDownload = async () => {
        setDownloadLoading(true)
        const imagesPath = containerImages.map((i) => i.image);
        const response = await fileZipService.download(id, imagesPath);
        setDownloadLoading(false)
        if (response?.success ?? false) {
            message.success(response.message)
        } else {
            message.error(response?.message ?? "Something Wrong")
        }
    }

    const handleModalImageDownload = async (type, index = 0) => {
        // console.log("[containerImages[index].filename]",containerImages)
        setDownloadLoading(true);
        let response;

        if (type === 'single') {
            response = await fileZipService.download("hi", [containerImages[index].image]);
        }
        else {
            const imagesPath = containerImages.map((i) => i.filename);
            console.log("imagesPath", imagesPath)

            response = await fileZipService.download("hi", imagesPath);
        }

        setDownloadLoading(false);
        if (response?.success ?? false) {
            message.success(response.message);
        } else {
            message.error(response?.message ?? 'Something went wrong');
        }
    }

    const downloadMenu = (index) => ({
        items: [
            {
                key: '1',
                label: 'Download This Image',
                onClick: () => handleModalImageDownload('single', index),
            },
            {
                key: '2',
                label: 'Download All Images',
                onClick: () => handleDownload(),
            },
        ],
    })
    return (
        <Modal
            open={modalVisible}
            onCancel={() => {
                setSelectedVehicle(null);
                setModalVisible(false);
            }}
            footer={null}
            width="80%"
            centered
            style={{ top: 15 }}
            styles={{
                padding: '0px',
                body: {
                    padding: '0px',
                    height: '700px',
                    paddingLeft: 0,
                    marginLeft: 0,
                    overflowY: 'hidden',
                    overflowX: 'hidden',
                },
            }}
        >
            <div className="w-full flex justify-between items-center mt-9">
                <div className='flex gap-5 items-center'>
                    <p className='text-base font-medium'>Compare Images</p>
                    <p className='bg-[#F1F5F9] px-3 text-center rounded-xl border'>{vehicles.length}{" "}Vehicles</p>
                </div>
                <Select
                    className="w-[30%] h-10"
                    value={selectedVehicle}
                    onChange={handleCarChange}
                    placeholder="Select Cars"
                >
                    {/* {vehicleImages.map((value, index) => (
                        <Option key={index} value={value.id}>
                            {`${value.name} - ${value.chasis}`}
                        </Option>
                    ))} */}

                    {vehicles.map((value, index) => (
                        <Option key={index} value={value.id}>
                            {`${value.vehicle} - ${value.chasis_no}`}
                        </Option>
                    ))}
                </Select>
            </div>

            <div className="flex w-full gap-5 p-5">
                {/* Container Left Section */}
                <div className="w-1/2  h-full p-3">
                    <Typography.Title level={4} className="text-center">
                        Container Upload
                    </Typography.Title>
                    <div className="relative">
                        <Carousel
                            ref={modalCarouselRef}
                            dots={false}
                            afterChange={(index) => {
                                setModalIndex(index);
                                thumbnailRefs.current[index]?.scrollIntoView({ behavior: 'smooth', inline: 'center' });
                            }}
                            style={{ textAlign: 'center', marginTop: 10, position: "relative" }}
                        >
                            {containerImages.map((image, index) => (
                                <div key={index} className='w-full relative'>
                                    <Image src={image.image}
                                        style={{ height: 390, width: '100%', borderRadius: 6 }}
                                        preview={false} />
                                    {/* <Button
                                        style={{ position: "absolute", bottom: 16, right: 90, zIndex: 20 }}
                                        onClick={() => {
                                            setStartIndex(index); // open preview starting at this image
                                            setPreviewVisible(true);
                                        }}
                                        icon={<EyeOutlined style={{ fontSize: "15px" }} />}
                                    >
                                    </Button> */}
                                </div>

                            ))}

                        </Carousel>
                        <Button
                            style={{
                                position: "absolute", // 👈 fixed instead of absolute
                                bottom: 16,
                                right: 80,
                                zIndex: 1000,
                            }}
                            onClick={() => {
                                setStartIndex(modalIndex); // open preview at current slide
                                setPreviewVisible(true);
                            }}
                            icon={<EyeOutlined style={{ fontSize: "15px" }} />}
                        />
                        <div style={{ display: "none" }}>
                            <Image.PreviewGroup
                                preview={{
                                    visible: previewVisible,
                                    current: startIndex,
                                    onVisibleChange: (vis) => setPreviewVisible(vis),
                                    onChange: (index) => setStartIndex(index),

                                }}
                            >
                                {containerImages.map((img, index) => (
                                    <Image key={index} src={img.image}
                                    />
                                ))}
                            </Image.PreviewGroup>
                        </div>

                        {/* <Dropdown menu={downloadMenu(modalIndex)} placement="bottomRight">
                            <Button
                                icon={<DownloadOutlined style={{ fontSize: 14 }} />}
                                loading={downloadLoading}
                                style={{ position: 'absolute', bottom: 16, right: 90, zIndex: 10 }}
                            />
                        </Dropdown> */}

                        <Text
                            style={{
                                position: 'absolute',
                                bottom: 16,
                                right: -20,
                                backgroundColor: 'white',
                                transform: 'translateX(-50%)',
                                zIndex: 10,
                                color: 'black',
                                padding: '4px 12px',
                                borderRadius: 4,
                                fontSize: 14,
                            }}
                        >
                            {modalIndex + 1} to {containerImages.length}
                        </Text>
                    </div>

                    {/* Carousel Controls */}
                    <Button
                        style={{ ...CustomArrow, left: "6%", }}
                        onClick={(e) => {
                            e.preventDefault();
                            modalCarouselRef.current?.prev();
                        }}
                        icon={<LeftOutlined style={{ fontSize: 14 }} />}
                    />
                    <Button
                        style={{ ...CustomArrow, left: "45%", }}
                        onClick={(e) => {
                            e.preventDefault();
                            modalCarouselRef.current?.next();
                        }}
                        icon={<RightOutlined style={{ fontSize: 14 }} />}
                    />

                    {/* Thumbnails */}
                    <div style={{ overflowX: 'hidden', whiteSpace: 'nowrap', paddingBottom: 8 }}>
                        {containerImages.map((img, index) => (
                            <div
                                key={index}
                                ref={(el) => (thumbnailRefs.current[index] = el)}
                                onClick={() => {
                                    modalCarouselRef.current.goTo(index);
                                    setModalIndex(index);
                                }}
                                style={{
                                    display: 'inline-block',
                                    border: modalIndex === index ? '2px solid #B63C3C' : 'none',
                                    borderRadius: 4,
                                    cursor: 'pointer',
                                    marginRight: 8,
                                }}
                            >
                                <Image src={img.image} width={85} height={100} style={{ objectFit: 'cover', borderRadius: 4 }} preview={false} />
                            </div>
                        ))}
                    </div>
                </div>

                {/* Vehicle Right Section */}

                {vehicles.length > 0 ? (
                    <div className="w-1/2 h-full p-3">
                        <Typography.Title level={4} className="text-center">
                            Vehicle Received
                        </Typography.Title>

                        {/* Spinner shown when loading */}

                        {vehicleLoading ? (
                            <div className="flex justify-center items-center h-[300px]">
                                <Spin size="large" />
                            </div>
                        ) : (
                            <>
                                <div className="relative">
                                    <Carousel
                                        ref={modalCarouselRef2}
                                        dots={false}
                                        afterChange={(index) => {
                                            setModalIndex2(index);
                                            thumbnailRefs2.current[index]?.scrollIntoView({ behavior: 'smooth', inline: 'center' });
                                        }}
                                        style={{ textAlign: 'center' }}
                                    >
                                        {singleVehicleImg.map((image, index) => (
                                            <div key={index} className='flex justify-center relative'>
                                                <Image src={image} style={{ height: 390, width: '100%', borderRadius: 6 }} preview={false} />

                                            </div>
                                        ))}
                                    </Carousel>

                                    <div style={{ display: "none" }}>
                                        <Image.PreviewGroup
                                            preview={{
                                                visible: previewVisible2,
                                                current: startIndex2,
                                                onVisibleChange: (vis) => setPreviewVisible2(vis),
                                                onChange: (index) => setStartIndex2(index),

                                            }}
                                        >
                                            {singleVehicleImg.map((img, index) => (
                                                <Image key={index} src={img} />
                                            ))}
                                        </Image.PreviewGroup>
                                    </div>

                                    {singleVehicleImg.length > 0 && !vehicleLoading && (
                                        <>
                                            <Button
                                                style={{
                                                    position: "absolute", bottom: 16, right: 90, zIndex: 1000,
                                                }}
                                                onClick={() => {
                                                    setStartIndex2(modalIndex2); // open preview starting at this image
                                                    setPreviewVisible2(true);
                                                }}
                                                icon={<EyeOutlined style={{ fontSize: "15px" }} />}
                                            >
                                            </Button>
                                            <Text
                                                style={{
                                                    backgroundColor: 'white',
                                                    transform: 'translateX(-50%)',
                                                    color: 'black',
                                                    padding: '5px 12px',
                                                    borderRadius: 4,
                                                    fontSize: 14,
                                                    position: 'absolute',
                                                    bottom: 16,
                                                    right: -20,
                                                    zIndex: 10,
                                                }}
                                            >
                                                {modalIndex2 + 1} to {singleVehicleImg.length}
                                            </Text>
                                        </>

                                    )}
                                </div>

                                {/* Controls */}
                                {singleVehicleImg.length > 0 && !vehicleLoading && (

                                    <>
                                        <Button
                                            style={{ ...CustomArrow, right: "43%", }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                modalCarouselRef2.current?.prev();
                                            }}
                                            icon={<LeftOutlined style={{ fontSize: 14 }} />}
                                        />
                                        <Button
                                            style={{ ...CustomArrow, right: "5%", }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                modalCarouselRef2.current?.next();
                                            }}
                                            icon={<RightOutlined style={{ fontSize: 14 }} />}
                                        />
                                    </>

                                )}
                                {/* Thumbnails */}
                                <div style={{ overflowX: 'hidden', whiteSpace: 'nowrap', paddingBottom: 8 }}>
                                    {singleVehicleImg.map((img, index) => (
                                        <div
                                            key={index}
                                            ref={(el) => (thumbnailRefs2.current[index] = el)}
                                            onClick={() => {
                                                modalCarouselRef2.current.goTo(index);
                                                setModalIndex2(index);
                                            }}
                                            style={{
                                                display: 'inline-block',
                                                border: modalIndex2 === index ? '1px solid #B63C3C' : 'none',
                                                borderRadius: 4,
                                                cursor: 'pointer',
                                                marginRight: 8,
                                            }}
                                        >
                                            <Image
                                                src={img}
                                                width={85} height={100}
                                                style={{ objectFit: 'cover', borderRadius: 4 }}
                                                preview={false}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </>)}
                    </div>
                ) : (
                    <div className="flex items-center justify-center w-full">
                        <Empty description={<Typography.Text>No Images</Typography.Text>} />
                    </div>
                )}

            </div>
        </Modal>
    );
};

const navBtnStyle = {
    width: 26,
    height: 26,
    borderRadius: '50%',
    backgroundColor: '#B83D3D',
    border: '1px solid #B83D3D',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
    cursor: 'pointer',
    color: 'white',
};

export default VehicleImageModal;
